import React from 'react'
import BackGroundDeem from 'src/components/common/BackgroundDeem'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { bottomInPageTransitionProps } from 'src/styles/animation'
import { Noto_body2_r14, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'
import styled, { css } from 'styled-components'
import free_coupon_detail_bottom_sheet from 'src/assets/images/free_coupon_detail/free_coupon_detail_bottom_sheet.png'
import LazyImage from 'src/components/common/LazyImage'
import Button, { ButtonOption2, ButtonOption7 } from 'src/components/common/Button'
import usePartnerEntry from 'src/hooks/usePartnerEntry.hook'
import usePageNav from 'src/hooks/usePageNav.hook'
import eventPopupParticle from 'src/assets/images/free_coupon_detail/event-popup-particle.json'
import Lottie from 'lottie-react'

export interface FreeCouponDetailBottomSheetProps {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const FreeCouponDetailBottomSheet = (props: FreeCouponDetailBottomSheetProps) => {
  const { isOpen, setIsOpen } = props
  const {
    value: { pCode },
  } = usePartnerEntry()
  const { mainPageNav } = usePageNav()

  if (!pCode || !isOpen) return <></>
  return (
    <React.Fragment>
      <BackGroundDeem />
      <Container
        $option="flex_column_space_between"
        $row_gap="16px"
        $style={S.BottomSheetContainer()}
        {...bottomInPageTransitionProps}
      >
        <S.TextContainer $option="flex_column" $row_gap="10px">
          <S.ConfettiImage animationData={eventPopupParticle} loop={false} autoplay={true} />
          <Typography $fontStyle={Noto_subheading_b18} $color="var(--black-100)">
            60% 핫딜 도착!
          </Typography>
          <Typography $fontStyle={Noto_body2_r14} $color="var(--black-100)">
            바로 받을 수 있는 치킨 / 버거 / 커피
            <br />
            최대 60% 할인이 있어요.
          </Typography>
        </S.TextContainer>
        <LazyImage
          src={free_coupon_detail_bottom_sheet}
          alt="핫딜 홍보 이미지"
          style={S.BottomSheetImage}
        />
        <Container $option="flex_column" $row_gap="12px">
          <Button
            option={ButtonOption7('black')}
            onClickFn={mainPageNav}
            className="btn_bottom_confirm"
          >
            확인
          </Button>
          <Button option={ButtonOption2('dark')} onClickFn={() => setIsOpen(false)}>
            닫기
          </Button>
        </Container>
      </Container>
    </React.Fragment>
  )
}
export default FreeCouponDetailBottomSheet

const S = {
  BottomSheetContainer: () => css`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    align-items: center;
    margin: auto;
    padding: 20px 24px;
    min-width: 320px;
    z-index: ${ZIndex.BottomSheet};
    border-radius: 30px 30px 0 0;
    background: var(--white);
    ${layoutMaxSize};
  `,

  TextContainer: styled(Container)`
    position: relative;
    align-items: center;
    text-align: center;
  `,
  ConfettiImage: styled(Lottie)`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 360px;
    z-index: 1;
  `,
  BottomSheetImage: css`
    width: 100%;
    max-width: 254px;
    height: 100%;
    object-fit: cover;
  `,
}
